/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransactionSummary
 */
export interface TransactionSummary {
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    annualAdministrationFees: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    annualFinancialIntermediaryFees: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    annualPortfolioManagementFees: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    capitalGainsTaxRecovered: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionSummary
     */
    clientFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionSummary
     */
    clientLastName: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionSummary
     */
    clientSecondNameInitial?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    closingBalance: number;
    /**
     * 
     * @type {Date}
     * @memberof TransactionSummary
     */
    closingBalanceDate: Date;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    dividendAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof TransactionSummary
     */
    inceptionDate: Date;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    incomeTax: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    initialInvestmentAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    interestAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    investmentPriceMovement: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    investments: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    netIncome: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    openingBalance: number;
    /**
     * 
     * @type {Date}
     * @memberof TransactionSummary
     */
    openingBalanceDate: Date;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    otherIncomeAmount: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionSummary
     */
    planName: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionSummary
     */
    planNumber: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    regularWithdrawal: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    totalInvestmentReturn: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    vatOnAnnualAdministrationFees: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    vatOnAnnualFinancialIntermediaryFees: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    withdrawal: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    collectiveInterest: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    marketFundsInterest: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    rEITIncome: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    netIRRForPeriod: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    netIRROneYear: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    netIRRThreeYears: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    netIRRFiveYears: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    grossIRRForPeriod: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    grossIRROneYear: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    grossIRRThreeYears: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    grossIRRFiveYears: number;
}

/**
 * Check if a given object implements the TransactionSummary interface.
 */
export function instanceOfTransactionSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "annualAdministrationFees" in value;
    isInstance = isInstance && "annualFinancialIntermediaryFees" in value;
    isInstance = isInstance && "annualPortfolioManagementFees" in value;
    isInstance = isInstance && "capitalGainsTaxRecovered" in value;
    isInstance = isInstance && "clientFirstName" in value;
    isInstance = isInstance && "clientLastName" in value;
    isInstance = isInstance && "closingBalance" in value;
    isInstance = isInstance && "closingBalanceDate" in value;
    isInstance = isInstance && "dividendAmount" in value;
    isInstance = isInstance && "inceptionDate" in value;
    isInstance = isInstance && "incomeTax" in value;
    isInstance = isInstance && "initialInvestmentAmount" in value;
    isInstance = isInstance && "interestAmount" in value;
    isInstance = isInstance && "investmentPriceMovement" in value;
    isInstance = isInstance && "investments" in value;
    isInstance = isInstance && "netIncome" in value;
    isInstance = isInstance && "openingBalance" in value;
    isInstance = isInstance && "openingBalanceDate" in value;
    isInstance = isInstance && "otherIncomeAmount" in value;
    isInstance = isInstance && "planName" in value;
    isInstance = isInstance && "planNumber" in value;
    isInstance = isInstance && "regularWithdrawal" in value;
    isInstance = isInstance && "totalInvestmentReturn" in value;
    isInstance = isInstance && "vatOnAnnualAdministrationFees" in value;
    isInstance = isInstance && "vatOnAnnualFinancialIntermediaryFees" in value;
    isInstance = isInstance && "withdrawal" in value;
    isInstance = isInstance && "collectiveInterest" in value;
    isInstance = isInstance && "marketFundsInterest" in value;
    isInstance = isInstance && "rEITIncome" in value;
    isInstance = isInstance && "netIRRForPeriod" in value;
    isInstance = isInstance && "netIRROneYear" in value;
    isInstance = isInstance && "netIRRThreeYears" in value;
    isInstance = isInstance && "netIRRFiveYears" in value;
    isInstance = isInstance && "grossIRRForPeriod" in value;
    isInstance = isInstance && "grossIRROneYear" in value;
    isInstance = isInstance && "grossIRRThreeYears" in value;
    isInstance = isInstance && "grossIRRFiveYears" in value;

    return isInstance;
}

export function TransactionSummaryFromJSON(json: any): TransactionSummary {
    return TransactionSummaryFromJSONTyped(json, false);
}

export function TransactionSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'annualAdministrationFees': json['AnnualAdministrationFees'],
        'annualFinancialIntermediaryFees': json['AnnualFinancialIntermediaryFees'],
        'annualPortfolioManagementFees': json['AnnualPortfolioManagementFees'],
        'capitalGainsTaxRecovered': json['CapitalGainsTaxRecovered'],
        'clientFirstName': json['ClientFirstName'],
        'clientLastName': json['ClientLastName'],
        'clientSecondNameInitial': !exists(json, 'ClientSecondNameInitial') ? undefined : json['ClientSecondNameInitial'],
        'closingBalance': json['ClosingBalance'],
        'closingBalanceDate': (new Date(json['ClosingBalanceDate'])),
        'dividendAmount': json['DividendAmount'],
        'inceptionDate': (new Date(json['InceptionDate'])),
        'incomeTax': json['IncomeTax'],
        'initialInvestmentAmount': json['InitialInvestmentAmount'],
        'interestAmount': json['InterestAmount'],
        'investmentPriceMovement': json['InvestmentPriceMovement'],
        'investments': json['Investments'],
        'netIncome': json['NetIncome'],
        'openingBalance': json['OpeningBalance'],
        'openingBalanceDate': (new Date(json['OpeningBalanceDate'])),
        'otherIncomeAmount': json['OtherIncomeAmount'],
        'planName': json['PlanName'],
        'planNumber': json['PlanNumber'],
        'regularWithdrawal': json['RegularWithdrawal'],
        'totalInvestmentReturn': json['TotalInvestmentReturn'],
        'vatOnAnnualAdministrationFees': json['VatOnAnnualAdministrationFees'],
        'vatOnAnnualFinancialIntermediaryFees': json['VatOnAnnualFinancialIntermediaryFees'],
        'withdrawal': json['Withdrawal'],
        'collectiveInterest': json['CollectiveInterest'],
        'marketFundsInterest': json['MarketFundsInterest'],
        'rEITIncome': json['REITIncome'],
        'netIRRForPeriod': json['NetIRRForPeriod'],
        'netIRROneYear': json['NetIRROneYear'],
        'netIRRThreeYears': json['NetIRRThreeYears'],
        'netIRRFiveYears': json['NetIRRFiveYears'],
        'grossIRRForPeriod': json['GrossIRRForPeriod'],
        'grossIRROneYear': json['GrossIRROneYear'],
        'grossIRRThreeYears': json['GrossIRRThreeYears'],
        'grossIRRFiveYears': json['GrossIRRFiveYears'],
    };
}

export function TransactionSummaryToJSON(value?: TransactionSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AnnualAdministrationFees': value.annualAdministrationFees,
        'AnnualFinancialIntermediaryFees': value.annualFinancialIntermediaryFees,
        'AnnualPortfolioManagementFees': value.annualPortfolioManagementFees,
        'CapitalGainsTaxRecovered': value.capitalGainsTaxRecovered,
        'ClientFirstName': value.clientFirstName,
        'ClientLastName': value.clientLastName,
        'ClientSecondNameInitial': value.clientSecondNameInitial,
        'ClosingBalance': value.closingBalance,
        'ClosingBalanceDate': (value.closingBalanceDate.toISOString()),
        'DividendAmount': value.dividendAmount,
        'InceptionDate': (value.inceptionDate.toISOString()),
        'IncomeTax': value.incomeTax,
        'InitialInvestmentAmount': value.initialInvestmentAmount,
        'InterestAmount': value.interestAmount,
        'InvestmentPriceMovement': value.investmentPriceMovement,
        'Investments': value.investments,
        'NetIncome': value.netIncome,
        'OpeningBalance': value.openingBalance,
        'OpeningBalanceDate': (value.openingBalanceDate.toISOString()),
        'OtherIncomeAmount': value.otherIncomeAmount,
        'PlanName': value.planName,
        'PlanNumber': value.planNumber,
        'RegularWithdrawal': value.regularWithdrawal,
        'TotalInvestmentReturn': value.totalInvestmentReturn,
        'VatOnAnnualAdministrationFees': value.vatOnAnnualAdministrationFees,
        'VatOnAnnualFinancialIntermediaryFees': value.vatOnAnnualFinancialIntermediaryFees,
        'Withdrawal': value.withdrawal,
        'CollectiveInterest': value.collectiveInterest,
        'MarketFundsInterest': value.marketFundsInterest,
        'REITIncome': value.rEITIncome,
        'NetIRRForPeriod': value.netIRRForPeriod,
        'NetIRROneYear': value.netIRROneYear,
        'NetIRRThreeYears': value.netIRRThreeYears,
        'NetIRRFiveYears': value.netIRRFiveYears,
        'GrossIRRForPeriod': value.grossIRRForPeriod,
        'GrossIRROneYear': value.grossIRROneYear,
        'GrossIRRThreeYears': value.grossIRRThreeYears,
        'GrossIRRFiveYears': value.grossIRRFiveYears,
    };
}

